// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"94110a69","190":"248073e9","222":"b442f483","311":"cec21c40","360":"7ba90c7e","453":"3dd8bc87","661":"898ccfdb","672":"1aec4f43","794":"21d5a876","853":"5391efd3","860":"72802ed3","983":"25a7675f","985":"cc4edfaf"}[chunkId] + ".chunk.js";
};